import UnlockIcon from './UnlockIcon';

export default UnlockIcon;